import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

const grid = 3;

export const getItemStyle = (
    draggableStyle?: Record<string, unknown>
): Record<string, unknown> => ({
    userSelect: "none",
    padding: grid * 2,
    width: "100%",
    border: `1px solid #E0E0E0`,
    boxSizing: "border-box",
    borderRadius: "4px",
    background: "white",
    marginBottom: "8px",
    ...draggableStyle,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

export const getItemStyleEmpty = (): Record<string, unknown> => ({
    userSelect: "none",
    padding: grid * 5,
    width: 250,
    border: `1px dashed #E0E0E0`,
    boxSizing: "border-box",
    borderRadius: "4px",
    background: "white",
});

export const getListStyle = (isNotDraggable: boolean): Record<string, unknown> => ({
    opacity: isNotDraggable ? 0.33 : 1,
    padding: "8px",
});

export const useDisplayParameterModalStyle = makeStyles(() =>
    createStyles({
        infoTooltip: {
            opacity: 0.75,
        },
        infoIcon: {
            width: "12px",
            height: "12px",
        },
        dragIndicatorIcon: {
            width: "16px",
            height: "16px",
        },
        dragAndDropContainer: {
            display: "grid",
            gridTemplateColumns: `repeat(3, 1fr)`,
            maxHeight: "50vh",
            overflowY: "scroll",
        },
        listGroup: {
            transition: "opacity 150ms ease",
        },
        listGroupDisabled: {
            opacity: 0.4,
            pointerEvents: "none",
        },
    })
);

export const useUserProfilSelectStyle = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            width: "180px",
            margin: theme.spacing(4),
            marginTop: theme.spacing(0),
        },
        label: {
            fontSize: "12px",
        },
        select: {
            minWidth: "150px",
            display: "flex",
            flexDirection: "column",
        },
    })
);
